export enum CompanyLabel {
  LABEL_MCKAY = 1,
  LABEL_QUINCY = 2,
  LABEL_ALL = 3,
  LABEL_VENDOR = 4,
  LABEL_MCKAY_VENDOR = 5,
  LABEL_QUINCY_VENDOR = 6,
  LABEL_ALL_VENDOR = 7
}
